import { ITypedModel } from 'core-ts-types';
import { Model } from 'utility-ts-orm';
import { ICourse, ISectionLabel } from '../../../interfaces/scheduler_interfaces';
import { Section } from '../../sections/builders/section_builder';

export type SelectedUnscheduledSectionModel = ITypedModel<Section>;

angular.module('capability-ng-scheduler').factory(
  'ngSelectedUnscheduledSectionModel',
  () =>
    new Model<Section>({
      id: -1,
      nk: '',
      cd: '',
      session: -1,
      course: -1,
      campus: -1,
      section_type: -1,
      seats_offered: -1,
      instructor_name: '',
      class_start_dt: '',
      class_end_dt: '',
      drop_start_dt: '',
      drop_end_dt: '',
      withdraw_end_dt: '',
      can_withdraw: false,
      is_unlimited_seating: false,
      is_droppable: false,
      is_repeatable: false,
      note: '',
      has_waitlist: false,
      _section_times: [],
      _course: {} as any,
      _campus: {} as any,
      _section_type: {} as any,
      _availability: {} as any,
      status: '',
      _linked_sections: [],
      title: '',
      _section_labels: {} as ISectionLabel
    })
);



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/views/unscheduled_sections/models/selected_unscheduled_section_model.ts